import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    bankAccountId: z.string(),
  }),
  response: z.void(),
};
